<div class="body-wrapper p-8">
    <h3 class="primary-text light-text">Edit row</h3>
    <div class="header">
        <div class="content" [formGroup]="editForm">
            <ng-container *ngFor="let field of rulevarservice.intel_view.fields">
                <div class="row">
                    <div class="field">
                        <p class="content-l primary-text">{{field.fieldName}}</p>
                    </div>
                    <div class="input">
                        <input type="text" class="input-border" [ngClass]="field.enrichable ? 'disabled-input non-clickable':''" [formControlName]="field.fieldName">
                        <div class="alert">
                            <p class="content-s alert-text">{{rulevarservice.intelViewError|oneError:editForm.get(field.fieldName).errors}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="footer">
        <button class="submit" [ngClass]="editForm.valid ? '' : 'permission-denied'" (click)="submitClicked()">Submit</button>
        <button class="cancel" (click)="closeClick()">Cancel</button>
    </div>
</div>
